const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;
const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;

export function logout() {
  if (csrfHeader && csrfToken) {
    postLogout(csrfHeader, csrfToken).catch((fehler) => logError("Logout-Fehler:", fehler));
  } else {
    logError("CSRF-Header oder Token nicht gefunden");
  }
}

function postLogout(csrfHeader, csrfToken) {
  return fetch("/logout", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      [csrfHeader]: csrfToken,
    },
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Die Netzwerkantwort war nicht in Ordnung");
      }

      return response;
    })
    .then(() => {
      window.location.href = "/?logout";
    });
}

function logError(nachricht, fehler) {
  console.error(nachricht, fehler);
}

document.addEventListener("DOMContentLoaded", () => {
  const logoutButtons = document.querySelectorAll(".logout-button");
  logoutButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      logout();
    });
  });
});
